<template>
  <div id="app">
    <vue-progress-bar/>
    <router-view/>
    <app-modal/>
  </div>
</template>
<script>
export default {
  name: "App",
};
</script>
<style lang="scss">
@import "~Sass/main.scss";
@import "~Sass/print/_layout.scss";
</style>
